module.exports = __webpack_public_path__ + "97ae97b4075263af174c14661dcc7c59.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-5.png
// module id = 2266
// module chunks = 0